import { useMainStore } from "@/store";

export const getTranslation = (id, params = {}) => {
  const store = useMainStore();

  let translation =
    store.translations &&
    store.translations[store.locale] &&
    store.translations[store.locale][id]
      ? store.translations[store.locale][id].label
      : "";

  if (Object.keys(params).length) {
    Object.entries(params).forEach((param) => {
      translation = translation.replace("__" + param[0] + "__", param[1]);
    });
  }

  return translation;
};
